<template>
  <div class="contact">
    <!-- banner部分 -->
    <div class="contact-banner">
      <div>
        <h2>联系我们</h2>
      </div>
    </div>
    <!-- 服务与咨询 -->
    <div class="container clearfix">
      <div class="contact-title">服务与咨询</div>
      <div class="contact-aside-title">斐宸售前、客服代表与资深顾问联手为您提供专业的咨询与购买服务</div>
      <div class="contact-content">
        <div class="contact-content-item list1 fl">
          <div class="fl">
            <h2>在线咨询</h2>
            <p>服务时间：9:00-18:00（工作日）<br />人工在线咨询，便捷、高效、即时</p>
          </div>
          <div class="fr">
            <img src="../../assets/img/contact/service_information.png" alt="" />
          </div>
        </div>
        <div class="contact-content-item list1 fr">
          <div class="fl">
            <h2>电话咨询</h2>
            <p>服务时间：9:00-18:00（工作日）</p>
          </div>
          <div class="fr join">
            <img src="../../assets/img/contact/service_telephone.png" alt="" />
          </div>
          <div class="contact-item">
            <h2>联系电话</h2>
            <h3>400-6016488</h3>
            <p>服务时间：9:00-18:00（工作日）</p>
            <p>联系地址：上海市嘉定区徐潘路1918号2幢3楼C区</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 其他 -->
    <div class="container clearfix">
      <div class="contact-title">其他</div>
      <div class="contact-content-list">
        <div class="contact-content-item list3 fl">
          <div class="fl">
            <img src="../../assets/img/contact/other_mailbox.png" alt="" />
          </div>
          <div class="fr">
            <h4>媒体合作、业务意见与建议</h4>
            <p>postmaster@feichan.tech</p>
          </div>
        </div>
        <div class="contact-content-item list3 fr">
          <div class="fl">
            <img src="../../assets/img/contact/other_personnel.png" alt="" />
          </div>
          <div class="fr">
            <h4>人才招聘</h4>
            <span class="join">加入我们</span>
            <div class="contact-item">
              <h2>联系电话</h2>
              <h3>400-6016488</h3>
              <p>服务时间：9:00-18:00（工作日）</p>
              <p>联系地址：上海市嘉定区徐潘路1918号2幢3楼C区</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Contact',
};
</script>
<style scoped>
.contact-banner {
  width: 100%;
  height: 594px;
  line-height: 594px;
  background: #000;
}
.contact-banner div {
  width: 100%;
  height: 100%;
  background: url(../../assets/img/contact/background_Image.png) no-repeat;
  background-size: cover;
}
.contact-banner h2 {
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.contact-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 50px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.contact-aside-title {
  width: 100%;
  margin-bottom: 50px;
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #666;
}
.contact-content-item {
  width: 535px;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 400;
  color: #666;
}
.contact-content-item.list1 {
  padding: 50px;
  height: 246px;
}
.contact-content-item.list2 {
  padding: 30px 88px 30px 88px;
  height: 291px;
}
.contact-content-item.fl {
  background: #0076de;
  color: #fff;
}
.contact-content-item.fr {
  background: #ffffff;
  box-shadow: 0px 2px 21px 8px rgba(0, 0, 0, 0.03);
}
.contact-content-item div h2 {
  margin-bottom: 20px;
  font-size: 50px;
  font-weight: bold;
}
.contact-content .contact-content-item .fr {
  width: 115px;
  height: 115px;
}
.contact-content-item.fr h2,
.contact-content-item.fr h3 {
  color: #333;
}
.contact-content-item div h3 {
  font-size: 30px;
  font-weight: bold;
}
.contact-content-list .contact-content-item {
  padding: 50px;
  background: #ffffff;
  box-shadow: 0px 2px 21px 8px rgba(0, 0, 0, 0.03);
  border-radius: 10px;
}
.contact-content-list div .fr {
  width: 288px;
}
.contact-content-list h4 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: 400;
  color: #000;
}
.contact-content-list p {
  font-size: 22px;
  font-weight: bold;
  color: #0076de;
}
.contact-content-list span {
  margin-top: 15px;
  display: block;
  width: 140px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  color: #fff;
  background: #0076de;
  border-radius: 8px;
}
.contact-content-list .list3 {
  height: 192px;
  margin-bottom: 100px;
}
.contact-content-item .contact-item {
  position: absolute;
  left: 36%;
  top: 120%;
  padding: 46px 99px 40px 37px;
  width: 535px;
  height: 280px;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0px 2px 21px 8px rgba(0, 0, 0, 0.03);
  display: none;
}
.contact-content-item .contact-item h2 {
  margin-bottom: 10px;
  font-size: 36px;
  color: #333;
  font-weight: 400;
}
.contact-content-item .contact-item h3 {
  margin-bottom: 30px;
  font-size: 36px;
  color: #0076de;
  font-weight: 400;
}
.contact-content-item .contact-item p {
  margin-bottom: 15px;
  font-size: 18px;
  color: #666;
  font-weight: 400;
  white-space: nowrap;
}
.contact-content-item .join:hover {
  cursor: pointer;
}
.contact-content-item .join:hover + .contact-item {
  display: block;
}
</style>
